export default __webpack_public_path__ + "roboto-v27-latin-700.7186f3.svg";